module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/rydb.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Frydb.png
// module id = 4WlB
// module chunks = 93